var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"gc-placeholder",style:({
    width: _vm.width || '',
    height: _vm.height || '20px',
    borderRadius: _vm.borderRadius || '4px',
  })},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }